import { Component, OnInit, NgModule } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';
import {Options} from 'select2';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerModule, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter, MatDatepickerInputEvent } from '@angular/material';
import { ApiService } from 'src/app/service/api.service';
import { DatePipe } from '@angular/common';
import { numValidation, mobile, email } from 'src/app/service/customValidation';
import { DataPassingService } from 'src/app/service/data-passing.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports:[
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
@Component({
  selector: 'app-admission',
  templateUrl: './admission.component.html',
  styleUrls: ['./admission.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class AdmissionComponent implements OnInit {
  personalFormGroup: FormGroup;
  eduFormGroup: FormGroup;
  familyFormGroup: FormGroup;
  educational:FormGroup;
  minorityList:Array<Select2OptionData>;
  categoryList:Array<Select2OptionData>;
  public options: Options;
  isSubmitted=false;
  bDisabled=false;
  editMode=false;
  isForm=true;
  isData=false;
  message:string='';
  isSuccess=false;
  isError=false;
  isGreater=false;
  isDisability=false;
  isCommunity=false;
  eduItems:FormArray;
  date : any;
  maxDate = new Date();
  maxValid=false;
  isDisable=false;
  isCompleted=false;
  isEditLoading=false;
  constructor(private _formBuilder: FormBuilder,private router:Router,private route:ActivatedRoute,private api:ApiService,private datepipe:DatePipe,private dataPass:DataPassingService) {
    this.personalFormGroup = this._formBuilder.group({
      id:['0'],
      first_name: ['', Validators.required],
      middle_name: ['', Validators.required],
      last_name: ['', Validators.required],
      uidno:[''],
      gender:['Male',Validators.required],
      dob:[''],
      address:['',Validators.required],
      city:['',Validators.required],
      age:['0',[numValidation()]],
      tq:['',Validators.required],
      dist:['',Validators.required],
      paddress:[''],
      pcity:[''],
      ptq:[''],
      pdist:[''],
      telephone:[''],
      mobile:['',[Validators.required,mobile()]],
      sameAddress:false,
      cstatus:[''],
      company:[''],
      caddress:[''],
      uintroducer:[''],
      uintroducerMobile:[''],
      ucourse_name:[''],
      uinstitute_name:[''],
      uinstitute_address:[''],
      ucourse_duration:[''],
      unote:['']
    });
    this.educational=this._formBuilder.group({
      introducer:['',Validators.required],
      introducerMobile:['',[Validators.required,mobile()]],
      course_name:['',Validators.required],
      institute_name:['',Validators.required],
      institute_address:['',Validators.required],
      course_duration:['0',[numValidation()]],
      years:[''],
      months:[''],
      course_scope:[''],
      regDate:['',Validators.required],
      dueDate:[''],
      course_fee:[''],
      note:['']
    });
   
   }

  ngOnInit() {
    this.dataPass.passData.subscribe(data=>{
      if(data.id>0)
      {
        this.isEditLoading=true;
        this.api.get('searchStudent?id='+data.id).subscribe(rdata=>{
          let userData=rdata.data[0];
          this.editMode=true;
          this.personalFormGroup.patchValue({
            id:userData.user_id,first_name:userData.first_name,middle_name:userData.middle_name,last_name:userData.last_name,gender:userData.gender,dob:userData.dob,address:userData.present_addr,tq:userData.tq,dist:userData.dist,city:userData.place,mobile:userData.mobile,email:userData.email,uidno:userData.uid,telephone:userData.phone,age:userData.age,cstatus:userData.current_status,company:userData.company,caddress:userData.caddress,uintroducer:userData.introducer,uintroducerMobile:userData.introducer_mobile,ucourse_name:userData.course_name,uinstitute_name:userData.institute,uinstitute_address:userData.institute_address,ucourse_duration:userData.course_duration,unote:userData.comment
          });
          this.isCompleted=(parseInt(userData.ustatus)==0)?true:false;
          this.isEditLoading=false;
        },(error)=>{});
      }
    });
    this.options = {
      width: '300',
      multiple: true,
      tags: true
    };
    
  }

  yearPlus()
  {
    let year=this.educational.controls.years.value;
    if(year=='')
    {
      this.educational.patchValue({years:1});
    }
    else if(year<10)
    {
      this.educational.patchValue({years:year+1});
    }
    
  }
  yearMinus()
  {
    let no=this.educational.controls.years.value;
    if(no=='')
    {
      this.educational.patchValue({years:1});
    }
    else if(parseInt(no)>1)
    {
      this.educational.patchValue({years:no-1});
    }
    
    
  }
  monthPlus()
  {
    let no=this.educational.controls.months.value;
    if(no=='')
    {
      this.educational.patchValue({months:1});
    }
    else if(no<11)
    {
      this.educational.patchValue({months:no+1});
    }
   
  }
  monthMinus()
  {
    let no=this.educational.controls.months.value;
    if(no=='' || no<1)
    {
      this.educational.patchValue({months:0});
    }
    else if(no<=11)
    {
      this.educational.patchValue({months:no-1});
    }
   
  }

  createFormItem(): FormGroup {
    return this._formBuilder.group({
      class:['',Validators.required],
      year_passing:[''],
      percentage:['']
    });
  }
  addFormItem(event): void {
    
    this.eduItems = this.eduFormGroup.get('eduItems') as FormArray;
    this.eduItems.push(this.createFormItem());
  }

  updateForm()
  {
    this.isSubmitted=true;
    if(this.personalFormGroup.invalid)
    {
      return false;
    }
    else
    {
      this.bDisabled=true;
      let formValues:any={...this.personalFormGroup.value,...this.educational.value};
    // formValues.admission_date=this.datepipe.transform(formValues.dob,"dd/MM/yyyy");
      formValues.dob=this.datepipe.transform(formValues.dob,"dd/MM/yyyy");
      
      formValues.due_date=this.datepipe.transform(formValues.due_date,"dd/MM/yyyy");
      this.api.post(formValues,"admission").subscribe(data=>{
        if(data.status)
        {
         
          
        }
        this.isData=false;
        this.isForm=true;
        this.isSubmitted=false;
        this.message=data.message;
        this.bDisabled=false;
        
        this.personalFormGroup.reset();
          this.educational.reset();
          this.dataPass.passDataService({});
          alert("Record updated successfully.");
        
        this.router.navigateByUrl('admin/studentList');
      },(error)=>{

      });
    }
  }

  removeFormItem(event) {
    this.eduItems.removeAt(this.eduItems.length - 1);
 }
  addressSame(e)
  {
    if(e.target.checked)
    {
      let personal=this.personalFormGroup.value;
      this.personalFormGroup.patchValue({
        paddress:personal.address,
        pcity:personal.city,
        pdist:personal.dist,
        ptq:personal.tq
      });
    }
    else
    {
      this.personalFormGroup.patchValue({
        paddress:null,
        pcity:null,
        pdist:null,
        ptq:null
      });
    }
   
  }

  onDisability(e)
  {
    if(e.target.value=='YES')
    {
      this.isDisability=true;
    }
    else
    {
      this.isDisability=false;
    }
    
  }

  onMinority(e)
  {
    if(e.target.value=='YES')
    {
      this.isCommunity=true;
    }
    else
    {
      this.isCommunity=false;
    }
    
  }
  calculateAge(event)
  {
  var momentVariable = moment(event.target.value, 'DD-MM-YYYY');
  var stringvalue = momentVariable.format('YYYY-MM-DD'); 
    let age=this.getAge(stringvalue);
    this.personalFormGroup.patchValue({age:age});

  }

  getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
  }

  personalValidate(form)
  {
    this.isSubmitted=true;
    if(this.personalFormGroup.invalid)
    {
      return false;
    }
    else
    {
      this.isSubmitted=false;
    }
  }

  eduValidate(form)
  {
    this.isSubmitted=true;
    if(this.eduFormGroup.invalid)
    {
      return false;
    }
    else
    {
      this.isSubmitted=false;
    }
  }

  otherValidate(form)
  {
    this.isSubmitted=true;
    if(this.familyFormGroup.invalid)
    {
      return false;
    }
    else
    {
      this.isSubmitted=false;
    }
  }

  

  saveAdmission()
  {
    let tday=new Date();
    this.isSubmitted=true;
    if(this.educational.invalid)
    {
      return false;
    }
    else
    {
      let formValues:any={...this.personalFormGroup.value,...this.educational.value};
      this.bDisabled=true;
      if(formValues.regDate<=tday && formValues.dueDate<=tday)
      {
        
        formValues.dob=this.datepipe.transform(formValues.dob,"dd/MM/yyyy");
        formValues.regDate=this.datepipe.transform(formValues.regDate,"dd/MM/yyyy");
        
        formValues.dueDate=this.datepipe.transform(formValues.dueDate,"dd/MM/yyyy");
        this.api.post(formValues,"admission").subscribe(data=>{
          if(data.status)
          {
            this.isData=false;
            this.isForm=true;
            this.message=data.message;
            this.personalFormGroup.reset();
            this.educational.reset();
            this.isSubmitted=false;
            alert(this.message);
            
          }
          else
          {
            alert(data.message);
          }
          window.location.reload();
          
          this.bDisabled=false;
        },(error)=>{

        });
      }
      else
      {
        this.maxValid=true;
      }
      
    }
    

  }

  

  resetForm()
  {
    this.isData=false;
    this.isForm=true;
    this.personalFormGroup.reset();
    this.familyFormGroup.reset();
    this.eduFormGroup.reset();
    this.educational.reset();
  }

  addEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisable=false;
    this.bDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt<=nwDt)
    {
      
      if(type=="age")
      { 
        let ndt=new Date(event.value._i.year,event.value._i.month,event.value._i.date);
        var momentVariable = moment(ndt, 'DD-MM-YYYY');
        var stringvalue = momentVariable.format('YYYY-MM-DD'); 
        let age=this.getAge(stringvalue);
        this.personalFormGroup.patchValue({age:age});
      }
      
    }
    else
    {
      this.isDisable=true;
      this.bDisabled=true;
      this.maxValid=true;
    }
    
    
  }

}
